import { BaseConverter } from "../../base/converters/base-converter.converter";
import { OrderModel } from "../models/order.model";
import { SearchResultModel } from "../../shared/models/search-result.model";
import { Order } from "../../shared/DTO/order";
import { OrdersResearchModel } from "../models/orders-research.model";
import { AgreementConverter } from "./agreement.converter";
import { OrderFileConverter } from "./order-file.converter";
import { IdentificationConverter } from "./identification.converter";
import { ProductConverter } from "./product.converter";
import { PurchaseConverter } from "./purchase.converter";
import { SubjectConverter } from "./subject.converter";
import { Injectable } from "@angular/core";
import { SearchOrdersResult } from "../../shared/DTO/searchResult";
import { OrdersResearchConverter } from "./orders-research.converter";

@Injectable()
export class OrderConverter extends BaseConverter<OrderModel, Order> {
  constructor(
    private agreementConverter: AgreementConverter,
    private orderFileConverter: OrderFileConverter,
    private identificationConverter: IdentificationConverter,
    private productConverter: ProductConverter,
    private purchaseConverter: PurchaseConverter,
    private subjectConverter: SubjectConverter,
    private ordersResearchConverter: OrdersResearchConverter
  ) {
    super();
  }

  convertToDto(model: OrderModel): Order {
    if (!model) {
      return undefined;
    }
    return {
      unit: model.unit,
      agreements: this.agreementConverter.convertToDtoList(model.agreements),
      booking: model.booking,
      contractState: model.contractState,
      contractType: model.contractType,
      files: this.orderFileConverter.convertToDtoList(model.files),
      identification: this.identificationConverter.convertToDto(
        model.identification
      ),
      operator: model.operator,
      operatorEmail: model.operatorEmail,
      orderId: model.orderId,
      products: this.productConverter.convertToDtoList(model.products),
      purchase: this.purchaseConverter.convertToDto(model.purchase),
      state: model.state,
      subjects: this.subjectConverter.convertToDtoList(model.subjects),
      userSubType: model.userSubType,
      userType: model.userType,
      accountCode: model.accountCode,
      customerCode: model.customerCode,
      commonOrdersId: model.commonOrdersId,
      externalCommonOrdersId: model.externalCommonOrdersId,
      insertDate: model.insertDate,
    };
  }

  convertToModel(dto: Order): OrderModel {
    if (!dto) {
      return null;
    }
    let model: OrderModel = new OrderModel();

    model.products = this.productConverter.convertToModelList(dto.products);
    model.orderId = dto.orderId;
    model.userType = dto.userType;
    model.state = dto.state;
    model.agreements = this.agreementConverter.convertToModelList(
      dto.agreements
    );
    model.booking = dto.booking;
    model.contractState = dto.contractState;
    model.contractType = dto.contractType;
    model.files = this.orderFileConverter.convertToModelList(dto.files);
    model.identification = this.identificationConverter.convertToModel(
      dto.identification
    );
    model.operator = dto.operator;
    model.operatorEmail = dto.operatorEmail;
    model.operatorNickname = dto.operatorNickname;
    model.purchase = this.purchaseConverter.convertToModel(dto.purchase);
    model.subjects = this.subjectConverter.convertToModelList(dto.subjects);
    model.unit = dto.unit;
    model.userSubType = dto.userSubType;
    model.accountCode = dto.accountCode;
    model.customerCode = dto.customerCode;
    model.commonOrdersId = dto.commonOrdersId;
    model.externalCommonOrdersId = dto.externalCommonOrdersId;
    model.insertDate = dto.insertDate;
    return model;
  }

  convertToSearchModel(
    dto: SearchOrdersResult
  ): SearchResultModel<OrderModel, OrdersResearchModel> {
    if (!dto) {
      return undefined;
    }
    let toReturn = new SearchResultModel<OrderModel, OrdersResearchModel>();
    toReturn.content = this.convertToModelList(dto.orders);
    toReturn.objectResearch = this.ordersResearchConverter.convertToModel(
      dto.ordersResearch
    );
    toReturn.total = dto.total;
    return toReturn;
  }
}
